import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

export type BillingInterval = "month" | "year";

export interface SubscriptionPlanPayload {
  name: string;
  description?: string;
  price: number;
  currency: string;
  interval: BillingInterval;
  features?: string[];
  appleProductId?: string;
  googleProductId?: string;
  isPopular?: boolean;
  isActive?: boolean;
}

const BASE_URL = "/api/admin/subscription-plans";

const SubscriptionPlanService = {
  createPlan: (data: SubscriptionPlanPayload): Promise<AxiosResponse> => {
    return instanceAxios.post(BASE_URL, data);
  },

  getPlans: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    sortOrder?: "asc" | "desc";
    isActive?: string;
  }): Promise<AxiosResponse> => {
    return instanceAxios.get(`${BASE_URL}/list`, {
      params: {
        page: params?.page || 1,
        limit: params?.limit || 10,
        search: params?.search || "",
        sortOrder: params?.sortOrder || "desc",
        isActive: params?.isActive || "",
      },
    });
  },

  getPlan: (id: string): Promise<AxiosResponse> => {
    return instanceAxios.get(`${BASE_URL}/${id}`);
  },

  updatePlan: (
    id: string,
    data: Partial<SubscriptionPlanPayload>
  ): Promise<AxiosResponse> => {
    return instanceAxios.patch(`${BASE_URL}/${id}`, data);
  },
};

export default SubscriptionPlanService;
